import React from "react";

export default function Header() {
  return (
    <div className="card-header">
      <h1>
        Is it raining? <i className="fas fa-cloud-showers-heavy"></i>
      </h1>
    </div>
  );
}
